import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { sleep } from '../../../../smoothr-web-app-core/utils/utils';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Api } from '../../../../smoothr-web-app-core/api/api';
import { RepositoryService } from '../../../../smoothr-web-app-core/services/repository/repository.service';
import { BrazeService } from '../../../services/braze.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-confirm-mailing-subs-modal',
	templateUrl: './confirm-mailing-subs-modal.component.html',
	styleUrl: './confirm-mailing-subs-modal.component.scss',
})
export class ConfirmMailingSubsModalComponent implements OnInit {
	form: FormGroup = new FormGroup({
		subsMail: new FormControl(false, [Validators.requiredTrue]),
	});
	loading = false;

	constructor(
		public modalCtrl: ModalController,
		private repositoryService: RepositoryService,
		private router: Router
	) {}

	static async show(modalCtrl: ModalController): Promise<{ val: boolean; email: string | undefined }> {
		const modal = await modalCtrl.create({
			cssClass: 'auto-height short-info',
			component: this,
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		await sleep(200);
		return result;
	}

	ngOnInit() {
		if (this.router.url.includes('home') && this.repositoryService._customerAuth.customer.isAnonymous) {
			this.form.addControl('email', new FormControl('', [Validators.required, Validators.email]));
		}
	}

	async confirm() {
		await this.modalCtrl.dismiss({ val: true, email: this.form?.get('email')?.value });
	}
}
